import elementExists from "../../core/utils/element-exists";

const PasswordProtection = function(){
    const formSection = document.querySelector( '.password-protection');
    if( elementExists( formSection )){
        const form = formSection.querySelector( 'form' );
        const data = form.dataset
        const key = data.key
        const path = data.path
        const input = form.querySelector( '#password');
        form.addEventListener( 'submit', function( e){
            e.preventDefault();
            if( input.value !== key ) alert( 'Incorrect Password');
            if( input.value == key ){
                document.body.classList.remove( 'password-protected')
                // window.localStorage.setItem( path , key );
                document.querySelector( '.password-protection').style.display='none';
            }
        })
    }
}

export default PasswordProtection